import React, { SetStateAction, useState } from "react";
import classNames from "classnames";
import styles from "./Header.module.scss";
import logo from "../../Img/logo/logo.png";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as MenuIcon } from "monoff-web-design-system/src/img/icon/24/menu.svg";
import { ReactComponent as LightModeIcon } from "monoff-web-design-system/src/img/icon/24/lightmode.svg";
import { ReactComponent as DarkModeIcon } from "monoff-web-design-system/src/img/icon/24/darkmode.svg";
import { useEffect } from "react";
import Sidebar from "../../common/Sidebar/Sidebar";
import { useRef } from "react";
export default function Header({
  isDarkMode,
  darkOnOff,
  isSidebar,
  setIsSidebar,
  setIsSelect,
  select,
  width,
}: {
  isDarkMode: boolean;
  darkOnOff: () => void;
  isSidebar: boolean;
  setIsSidebar: React.Dispatch<SetStateAction<boolean>>;
  setIsSelect: React.Dispatch<SetStateAction<string>>;
  select: (menu: string) => boolean;
  width: number;
}) {
  const [isOpen, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const active = document.getElementsByClassName(styles.activeMenu);
    const darkActive = document.getElementsByClassName(styles.DarkActiveMenu);
    if (location.pathname === "/") {
      active[0]?.classList?.replace(styles.activeMenu, styles.inactiveMenu);
      darkActive[0]?.classList?.replace(
        styles.DarkActiveMenu,
        styles.DarkInactiveMenu
      );
    }
  }, [location.pathname]);
  useEffect(() => {
    if (width > 769) {
      setIsSidebar(false);
    }
  }, [setIsSidebar, width]);
  const onClick = (e: any): void => {
    setIsSelect(e.target.innerText);
    setIsSidebar(false);
  };
  const homeClick = () => {
    const active = document.getElementsByClassName(styles.activeMenu);
    const darkActive = document.getElementsByClassName(styles.DarkActiveMenu);
    active[0].classList.replace(styles.activeMenu, styles.inactiveMenu);
    darkActive[0].classList.replace(
      styles.DarkActiveMenu,
      styles.DarkInactiveMenu
    );
  };

  const side = useRef();

  // button 클릭 시 토글
  const toggleMenu = (): void => {
    setOpen(true);
    setIsSidebar(true);
  };
  const onClose = () => {
    setOpen(false);
    setIsSidebar(false);
  };

  useEffect(() => {
    if (isSidebar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isSidebar]);
  return (
    <div
      className={classNames(
        !isDarkMode ? styles.container : styles.darkContainer
      )}
    >
      <section className={styles.header_box}>
        <div className={styles.logoContainer}>
          <Link to="/" onClick={homeClick}>
            <img src={logo} alt="" className={styles.logo} />
            <p className={`${styles.logo_text} label-L`}>CAREERS</p>
          </Link>
        </div>

        <ul className={styles.menuList}>
          <Link to="/culture">
            {!isDarkMode && (
              <li
                onClick={onClick}
                className={classNames(
                  select("문화와 비전") || location.pathname === "/culture"
                    ? `${styles.activeMenu} label-kr-M`
                    : `${styles.inactiveMenu} label-kr-M`
                )}
              >
                문화와 복지
              </li>
            )}
            {isDarkMode && (
              <li
                onClick={onClick}
                className={classNames(
                  select("문화와 비전") || location.pathname === "/culture"
                    ? `${styles.DarkActiveMenu} label-kr-M`
                    : `${styles.DarkInactiveMenu} label-kr-M`
                )}
              >
                문화와 복지
              </li>
            )}
          </Link>
          <Link to="/position">
            {!isDarkMode && (
              <li
                onClick={onClick}
                className={classNames(
                  select("채용 중인 직무") ||
                    location.pathname.split("/")[1].includes("position")
                    ? `${styles.activeMenu} label-kr-M`
                    : `${styles.inactiveMenu} label-kr-M`
                )}
              >
                채용 중인 직무
              </li>
            )}
            {isDarkMode && (
              <li
                onClick={onClick}
                className={classNames(
                  select("채용 중인 직무") ||
                    location.pathname.split("/")[1].includes("position")
                    ? `${styles.DarkActiveMenu} label-kr-M`
                    : `${styles.DarkInactiveMenu} label-kr-M`
                )}
              >
                채용 중인 직무
              </li>
            )}
          </Link>
          {/* <Link to="/faq">
          {!isDarkMode && (
            <li
              onClick={onClick}
              className={classNames(
                select("자주 묻는 질문") || location.pathname === "/faq"
                  ? styles.activeMenu
                  : styles.inactiveMenu
              )}
            >
              자주 묻는 질문
            </li>
          )}
          {isDarkMode && (
            <li
              onClick={onClick}
              className={classNames(
                select("자주 묻는 질문") || location.pathname === "/faq"
                  ? styles.DarkActiveMenu
                  : styles.DarkInactiveMenu
              )}
            >
              자주 묻는 질문
            </li>
          )}
        </Link> */}
          {/* <div className={styles.darkModeCheck}>
            {!isDarkMode ? (
              <DarkModeIcon
                onClick={darkOnOff}
                className={classNames(styles.modeBtn)}
              />
            ) : (
              <LightModeIcon
                onClick={darkOnOff}
                className={classNames(styles.modeBtn)}
              />
            )}
          </div> */}
          <MenuIcon className={styles.menuIcon} onClick={toggleMenu} />
        </ul>
      </section>

      {isSidebar && (
        <Sidebar
          side={side}
          isOpen={isOpen}
          setOpen={setOpen}
          onClose={onClose}
          onClick={onClick}
          isDarkMode={isDarkMode}
          select={select}
        ></Sidebar>
      )}
    </div>
  );
}
